/* eslint-disable */
import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Search, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Input } from "./ui/input";
import { Button } from "./ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function ChangeCustomerDialog({ order, open, onClose, onChanged }) {
  const [search, setSearch] = useState("");
  const [customers, setCustomers] = useState([]);
  const [selected, setSelected] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) { setSearch(""); setSelected(null); return; }
    const tm = setTimeout(async () => {
      try {
        const r = await axios.get(`${API}/customers${search ? `?search=${encodeURIComponent(search)}` : ""}`);
        setCustomers((r.data || []).filter((c) => c.id !== order?.customer_id));
      } catch { /* ignore */ }
    }, 250);
    return () => clearTimeout(tm);
  }, [open, search, order?.customer_id]);

  const save = async () => {
    if (!selected) return;
    setSaving(true);
    try {
      await axios.post(`${API}/orders/${order.id}/change-customer`, { customer_id: selected.id });
      toast.success(`Ordine ${order.order_number} intestato a ${selected.business_name}`);
      onChanged?.();
      onClose();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore cambio cliente");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-lg bg-white" data-testid="change-customer-dialog">
        <DialogHeader>
          <DialogTitle>Cambia cliente — {order?.order_number}</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-stone-600">
          Cliente attuale: <strong>{order?.customer?.customer_name}</strong>.<br />
          Prezzi e quantità restano invariati; IVA e provvigioni vengono ricalcolate per il nuovo cliente.
        </p>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400" />
          <Input placeholder="Cerca il nuovo cliente..." value={search} onChange={(e) => setSearch(e.target.value)} className="pl-10 bg-white border-stone-300" data-testid="change-customer-search" autoFocus />
        </div>
        <div className="max-h-64 overflow-y-auto border border-stone-200 rounded-lg divide-y divide-stone-100">
          {customers.length === 0 && <p className="p-4 text-sm text-stone-400 text-center">Nessun cliente trovato</p>}
          {customers.map((c) => (
            <button
              key={c.id}
              onClick={() => setSelected(c)}
              className={`w-full text-left p-2.5 text-sm hover:bg-stone-50 ${selected?.id === c.id ? "bg-[#8A1C2A]/10 border-l-4 border-[#8A1C2A]" : ""}`}
              data-testid={`change-customer-option-${c.id}`}
            >
              <span className="font-medium text-stone-900">{c.business_name}</span>
              <span className="block text-xs text-stone-500">{c.city || ""}{c.vat_number ? ` · P.IVA ${c.vat_number}` : ""}</span>
            </button>
          ))}
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onClose} className="border-stone-300" data-testid="change-customer-cancel">Annulla</Button>
          <Button onClick={save} disabled={!selected || saving} className="bg-[#8A1C2A] hover:bg-[#6B1420] text-white" data-testid="change-customer-confirm">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Conferma cambio"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
